<template>
  <div class="animated fadeIn" >
    <div class="m-5">

      <div class="m-5" v-if="data">
        <gofix-text-field label="QueueName" oneline>{{data.QueueName}}</gofix-text-field>
        <gofix-text-field label="OrginalCallerID" oneline>{{data.OrginalCallerID}}</gofix-text-field>
        <gofix-text-field label="IVR" oneline>{{data.IVR}}</gofix-text-field>
        <gofix-text-field label="DIDNumber" oneline>{{data.DIDNumber}}</gofix-text-field>
        <gofix-text-field label="Menu1" oneline>{{data.Menu1}}</gofix-text-field>
        <gofix-text-field label="Menu2" oneline>{{data.Menu2}}</gofix-text-field>
        <gofix-text-field label="Menu3" oneline>{{data.Menu3}}</gofix-text-field>
        <gofix-text-field label="Pincode" oneline>{{data.Pincode}}</gofix-text-field>
        <gofix-text-field label="BuildingType" oneline>{{data.BuildingType}}</gofix-text-field>
        <gofix-text-field label="FloorNumber" oneline>{{data.FloorNumber}}</gofix-text-field>
        <gofix-text-field label="UnitNumber" oneline>{{data.UnitNumber}}</gofix-text-field>
        <gofix-text-field label="ORINumber" oneline>{{data.ORINumber}}</gofix-text-field>
        <gofix-text-field label="AgentId" oneline>{{data.AgentId}}</gofix-text-field>
        <gofix-text-field label="AwsConnectId" oneline>{{data.AwsConnectId}}</gofix-text-field>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loaded: false,
      iframe: {
        src: 'https://nltcc.s3-ap-southeast-1.amazonaws.com/IFrame/index.htm',
      },
      data: null
    }
  },
  mounted() {
    window.addEventListener('message', this.receiveMessage)
  },
  methods:{
    receiveMessage(event){
      if(event.data.AwsConnectId ){
        console.log(event);
        this.data = event.data
      }
    },
    testPostmessage(){
      window.postMessage({
        QueueName: "" ,
        OrginalCallerID: "",
        IVR: "",
        DIDNumber: "",
        Menu1: "",
        Menu2: "",
        Menu3: "",
        Pincode: "",
        BuildingType:"" ,
        FloorNumber: "",
        UnitNumber: "",
        ORINumber: "",
        AgentId : "",
        AwsConnectId : "Test"
      }, "*");
    }
  }
}
</script>
